/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-param-reassign */
import { addLocale } from "primereact/api";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import Dialog from "../../../components/Dialog";
import { ptBrDatepickerTranslations } from "../../../i18n/locales/pt-br";
import AgendaDTO from "../../../model/dto/AgendaDTO";
import ModalCallback from "../../../model/ModalCallback";
import ButtonStyles from "../../../styles/components/ButtonStyles";
import CheckRadioStyles from "../../../styles/components/CheckRadioStyles";
import DialogStyles from "../../../styles/components/DialogStyles";
import Abono from "./Abono";
import ContentAntecipacao from "./Antecipacao";
import ContentEsquecimento from "./Esquecimento";
import ContentAusencia from "./Ausencia";
import ContentAusenciaJustificada from "./AusenciaJustificada";
import DialogMessage from "../../../components/DialogMessage";
import {
    StatusCheckinEnum,
    StatusCheckinEnumLabel,
} from "../../../model/Enums/StatusCheckinEnum";
import { Routes } from "../../../model/Enums/RoutesEnum";

addLocale("pt-BR", ptBrDatepickerTranslations);

const { DefaultButtonLink } = ButtonStyles;
const { StyledModalTitle, StyledContainerButton } = DialogStyles;

interface IModalJustifyCheckinProps {
    open: boolean;
    onClose?: (callback?: ModalCallback) => void;
    parametrosAgenda?: any;
    detail: AgendaDTO;
    refreshScheduleData?: () => void;
    refreshScheduleCard?: (cartaoAgendaId: number[]) => void;
    docente?: any;
}

interface IJustifyCheckinReasons {
    esquecimento: boolean;
    antecipacao: boolean;
    abono: boolean;
    ausencia: boolean;
    ausenciaJustificada: boolean;
}

// Helper functions to reduce cognitive complexity
function getRadioButtons(
    justifyCheckinReasons: IJustifyCheckinReasons,
    handleJustifyCheckinReasonsSelected: (reason: string) => void
) {
    return {
        abonoLegal: (
            <CheckRadioStyles.StyledFormCheck
                inline
                label="Abono Legal"
                name="group1"
                type="radio"
                id="inline-1"
                checked={justifyCheckinReasons.abono}
                onChange={() => handleJustifyCheckinReasonsSelected("abono")}
            />
        ),
        antecipacao: (
            <CheckRadioStyles.StyledFormCheck
                inline
                label="Antecipação"
                name="group2"
                type="radio"
                id="inline-2"
                checked={justifyCheckinReasons.antecipacao}
                onChange={() =>
                    handleJustifyCheckinReasonsSelected("antecipacao")
                }
            />
        ),
        esquecimento: (
            <CheckRadioStyles.StyledFormCheck
                inline
                label="Esquecimento"
                name="group3"
                type="radio"
                id="inline-3"
                checked={justifyCheckinReasons.esquecimento}
                onChange={() =>
                    handleJustifyCheckinReasonsSelected("esquecimento")
                }
            />
        ),
        ausencia: (
            <CheckRadioStyles.StyledFormCheck
                inline
                label="Ausência"
                name="group3"
                type="radio"
                id="inline-4"
                checked={justifyCheckinReasons.ausencia}
                onChange={() => handleJustifyCheckinReasonsSelected("ausencia")}
            />
        ),
        ausenciaJustificada: (
            <CheckRadioStyles.StyledFormCheck
                inline
                label="Ausência justificada"
                name="group3"
                type="radio"
                id="inline-5"
                checked={justifyCheckinReasons.ausenciaJustificada}
                onChange={() =>
                    handleJustifyCheckinReasonsSelected("ausenciaJustificada")
                }
            />
        ),
    };
}

function getRadiosNode({
    abonoLegalRadio,
    antecipacaoRadio,
    showFallback,
    isMinhaAgenda,
    radioButtons,
}: {
    isAusencia: boolean;
    shouldShowAbonoLegal: boolean;
    abonoLegalRadio: React.ReactNode;
    antecipacaoRadio: React.ReactNode;
    showFallback: boolean;
    isMinhaAgenda: boolean;
    radioButtons: ReturnType<typeof getRadioButtons>;
}) {
    const loggedUser = JSON.parse(localStorage.getItem("user") ?? "{}");
    const { isDac } = loggedUser;
    return (
        <>
            {abonoLegalRadio}
            {antecipacaoRadio}
            {showFallback && (
                <>
                    {isMinhaAgenda && radioButtons.ausencia}
                    {isDac && radioButtons.abonoLegal}
                    {radioButtons.antecipacao}
                    {radioButtons.esquecimento}
                </>
            )}
        </>
    );
}

const ModalJustifyCheckin: React.FC<IModalJustifyCheckinProps> = (props) => {
    const [justifyCheckinReasons, setJustifyCheckinReasons] =
        useState<IJustifyCheckinReasons>({
            abono: false,
            antecipacao: false,
            esquecimento: false,
            ausencia: false,
            ausenciaJustificada: false,
        });

    const { detail, open, onClose } = props;
    const checkinStatus = detail?.statusCheckin as string;
    const [successMessage, setSuccessMessage] = useState(false);

    const setAllObjectValuesToFalse = (obj: any) => {
        Object.keys(obj).forEach((key) => {
            obj[key] = false;
        });
    };

    const handleJustifyCheckinReasonsSelected = (reason: string) => {
        setAllObjectValuesToFalse(justifyCheckinReasons);
        setJustifyCheckinReasons({
            ...justifyCheckinReasons,
            [reason]: true,
        });
    };

    const handleShowSucessMessage = () => {
        setSuccessMessage(true);
    };

    const handleCloseDialogSuccess = () => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        props?.refreshScheduleCard &&
            props?.refreshScheduleCard([props.detail.cartaoAgendaId]);
        setSuccessMessage(false);
        props.onClose?.();
        props?.refreshScheduleData?.();
    };

    const dialogSuccess = (
        <DialogMessage
            type="success"
            show={Boolean(successMessage)}
            title="Justificativa enviada com sucesso!"
            onClose={handleCloseDialogSuccess}
        />
    );

    const location = useLocation();
    const pathLocation = location.pathname.split("/");
    const loggedUser = JSON.parse(localStorage.getItem("user") ?? "{}");

    const exibirAbonoLegal = [
        StatusCheckinEnumLabel.get(StatusCheckinEnum.Dispensado),
        StatusCheckinEnumLabel.get(StatusCheckinEnum.Compensado),
        StatusCheckinEnumLabel.get(StatusCheckinEnum.PendenciaJustificativa),
    ];

    const radioButtons = getRadioButtons(
        justifyCheckinReasons,
        handleJustifyCheckinReasonsSelected
    );

    const abonoLegalRadio =
        exibirAbonoLegal.includes(checkinStatus) && radioButtons.abonoLegal;

    const antecipacaoRadio =
        checkinStatus ===
            StatusCheckinEnumLabel.get(
                StatusCheckinEnum.DesabilitadoInterjornada
            ) && radioButtons.antecipacao;

    const isAusencia = props.detail.statusCheckin === "Ausência";
    const isMinhaAgenda = pathLocation[1] === Routes.MinhaAgenda;
    const showFallback = !abonoLegalRadio && !antecipacaoRadio;

    const shouldShowAbonoLegal = loggedUser.isDac;

    const radios = getRadiosNode({
        isAusencia,
        shouldShowAbonoLegal,
        abonoLegalRadio,
        antecipacaoRadio,
        showFallback,
        isMinhaAgenda,
        radioButtons,
    });

    return (
        <>
            <Dialog
                openModal={open && !successMessage}
                onHide={onClose}
                size="width-700 modal-radius-8"
            >
                <StyledModalTitle className="mb-5">
                    Justificar check-in não realizado
                </StyledModalTitle>
                {radios}

                {justifyCheckinReasons.esquecimento && (
                    <ContentEsquecimento
                        props={props}
                        setSuccessMessage={handleShowSucessMessage}
                    />
                )}
                {justifyCheckinReasons.ausencia && (
                    <ContentAusencia
                        props={props}
                        setSuccessMessage={handleShowSucessMessage}
                    />
                )}
                {justifyCheckinReasons.ausenciaJustificada && (
                    <ContentAusenciaJustificada
                        props={props}
                        setSuccessMessage={handleShowSucessMessage}
                    />
                )}
                {justifyCheckinReasons.antecipacao && (
                    <ContentAntecipacao props={props} />
                )}
                {justifyCheckinReasons.abono && shouldShowAbonoLegal && (
                    <Abono
                        props={props}
                        setSuccessMessage={handleShowSucessMessage}
                    />
                )}
                <StyledContainerButton className="mt-3">
                    <DefaultButtonLink
                        onClick={() => {
                            onClose?.();
                        }}
                    >
                        Cancelar
                    </DefaultButtonLink>
                </StyledContainerButton>
            </Dialog>
            {successMessage && dialogSuccess}
        </>
    );
};

export default ModalJustifyCheckin;
